// Called by : src/components/question/Question.vue (answer-mcq)

<template>
  <base-modal ref="base-modal" pageId="answer_mcq" pageClass="answer" modalClass="modal-lg" modalDataBack="true" modalDataKey="true" :key="keyModal">
    
    {{ forceUpdate }}

    <template #header>
      <h2 id="answer_mcq_title" class="modal-title " :class="getClassTitle()">
        <sound-player :url="question.audioQuestion" role="answerQuestion" tone="btn-outline-warning mr-3"></sound-player>
        <span v-html="questionQuestion"></span>
        <!-- {{ questionQuestion }} -->
      </h2>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    
    <template #body>
      <div class="answer_props text-left" :style="getCheckStyle()">
        <div class="form_check my-2" v-for="proposal in question.props" :key="proposal.index">
          <label class="form_check_label text-wrap" :class="getClassLabel(proposal.audioTitle)" :for="proposal.index">
            <sound-player :url="proposal.audioTitle" role="answerProposal" tone="btn-outline-secondary mr-4"></sound-player>
            <input class="form_check_input" type="checkbox" :id="proposal.index" v-model="answer" :value="proposal.zkp" />
            <span class="form_check_icon"><b></b></span>
            <span v-html="getProp(proposal.prop)"></span>
          </label>
        </div>
      </div>
    </template>
    
    <template #footer>
      <div class="w-100">
        <div  id="chk_indice" class="alert alert-info text-center font-weight-bold " :class="alertClass" role="alert">
          <span>{{nbrPrpUsr}}&nbsp;/&nbsp;{{nbrPrpOk}}&nbsp;/&nbsp;{{nbrPrpAll}}</span>
        </div>
        <button type="submit" class="btn_modal_submit btn btn-primary btn-lg btn-block" :disabled="getDisabled()" @click.stop="save">
          <span class="oi oi-check mr-2"></span>
          {{ $t('modals.validate') }}
        </button>
      </div>
    </template>

    {{ forceRefresh }}

  </base-modal >
</template>

<script>
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal' 
import SoundPlayer from '@/components/misc/SoundPlayer'

export default {
  components: {
    BaseModal,
    SoundPlayer,
  },
  props: {
    question: Object,
    isfr: Boolean,
  },
  data() {
    return {
      answer: [],
      langFr: true,
      questionQuestion: "",
      keyModal: false,
      nbrPrpUsr: 0,
      nbrPrpAll: 0,
      nbrPrpOk: 0,
      isCheckExact: false,
      isCheckIndice: false,
      indiceClass: "text-danger",
      alertClass: "alert-danger",
    }
  },
  methods: {
    save() {
      var sAnswer = this.answer.join('\n');
      this.answer = [];
      this.nbrPrpAll = 0;
      this.nbrPrpOk = 0;
      this.questionQuestion = "";
      // this.question = {};
      $('#answer_mcq').modal('hide');
      this.$emit('save', sAnswer);
    },
    getCheckStyle() {
      return '--check-icon:url("' + constants.assets.iconCheckSvgCode + '");';
    },
    getClassTitle() {
      return { 'answer_mcq_title': this.question.audioQuestion }
    },
    getClassLabel(sPropTitle) {
      return { 'form_check_label_audio': sPropTitle }
    },
    getDisabled() {
      //  :class="indiceClass"
      this.nbrPrpUsr = 0 + this.answer.length;

      // Activation/désctivation du bouton "Continuer"
      if (this.isCheckExact) {
        var bOff = Boolean((!this.nbrPrpUsr) || (this.nbrPrpUsr !== this.nbrPrpOk));
      } else {
        var bOff = Boolean(!this.nbrPrpUsr);
      }
      f_setModalBtnOff_v(bOff);

      // Type d'affichage de l'indice
      if (this.isCheckIndice) {
        var bTyp = Boolean((!this.nbrPrpUsr) || (this.nbrPrpUsr !== this.nbrPrpOk));
      } else {
        var bTyp = false;
      }
      if (bTyp) {
        this.indiceClass = "text-danger";
        this.alertClass = "alert-danger";
      } else {
        this.indiceClass = "text-primary";
        this.alertClass = "alert-success";
      }

      return bOff;
    },
    getKey(sId) {
      this.answer = [];
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    getProp(sProp) {
      if (this.langFr) return f_setCleanSpacesFr_s(sProp);
      return sProp;
    },
  },
  computed: {
    forceUpdate() {
      // this.langFr = Boolean(this.lesson.lang.toLowerCase() === "fr");
      this.questionQuestion = (this.isfr) ? f_setCleanSpacesFr_s(this.question.question) : this.question.question;
      if (!this.keyModal) this.keyModal = this.getKey('ModalMcq');
      this.nbrPrpAll = Number(this.question.nbrPrpAll);
      this.nbrPrpOk = Number(this.question.nbrPrpOk);
      this.isCheckExact = Boolean(this.lesson.isCheckExact);
      this.isCheckIndice = Boolean(this.lesson.isCheckIndice);
     return '';
    },
    forceRefresh() {
      this.getDisabled();
      return '';
    },
    lesson() {
      return this.$store.state.lesson
    },
  },
  mounted: function() {
    this.answer = [];
    this.keyModal = false;
  },
}

/*
      <br>
      <small>{{ lesson.name }}</small>
*/
</script>

<style scoped>

#chk_indice {
  display: block;
  font-size: 120% !important;
  padding: 6px;
  margin-bottom: 6px;
}

h2.answer_mcq_title {
  padding-left: 56px !important;
  text-indent: -56px !important;
}

label.form_check_label {
  color: #000;
  cursor: pointer;
  position: relative;
  font-size: 1.8rem;
  line-height: 1.2em;
  padding-left: 44px;
  text-indent: -44px;
}
label.form_check_label_audio {
  padding-left: 104px;
  text-indent: -112px;
}
input.form_check_input {
  display: none;
}
span.form_check_icon,
span.form_check_icon > b {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 10%;
  cursor: pointer;
}
span.form_check_icon {
  width: 34px;
  height: 34px;
  margin: 0 0.25rem 0 0;
  border: 5px solid #888;
  background-color: #fff;
  position: relative;
  top: 0.5rem;
  text-indent: 0;
}
span.form_check_icon > b {
  width: 24px;
  height: 24px;
  border: 1px solid #fff;
  background-color: #fff;
  position: absolute;
  top: 0;
  opacity: 0;
  background-image: var(--check-icon);
  background-repeat:no-repeat;
  background-position:0 0;
  background-size:contain;
}
label.form_check_label:hover > span.form_check_icon,
span.form_check_icon:hover {
  box-shadow: 2px 2px 4px #bbb;
}
label.form_check_label:active > span.form_check_icon,
span.form_check_icon:active {
  border-color: #000;
  box-shadow: none;
}
label.form_check_label:hover > span.form_check_icon > b,
span.form_check_icon:hover > b,
span.form_check_icon > b:hover {
  opacity: 0.5;
}
label.form_check_label:active > span.form_check_icon > b,
span.form_check_icon:active > b,
span.form_check_icon > b:active {
  opacity: 1;
}
input.form_check_input:checked + span.form_check_icon {
  border-color: #06c;
  box-shadow: none;
}
input.form_check_input:checked:hover + span.form_check_icon,
input.form_check_input:checked + span.form_check_icon:hover {
  border-color: #06c;
  box-shadow: 2px 2px 4px #bbb;
}
input.form_check_input:checked:active + span.form_check_icon,
input.form_check_input:checked + span.form_check_icon:active {
  border-color: #000;
  box-shadow: none;
}
input.form_check_input:checked + span.form_check_icon > b {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/question/AnswerMcq.vue